import { EntitySelectorsFactory } from '@ngrx/data';

import { TipoMovilidad } from './tipos-movilidad.model';

export const tipoMovilidadSelectors =
  new EntitySelectorsFactory().create<TipoMovilidad>('TipoMovilidad');

export const selectAllTiposMovilidad =
  tipoMovilidadSelectors.selectEntities;

